// File: src/pages/Admin/GPTMaintainerAdmin.js

import React, { useState } from "react";
import axios from "axios";
import config from "../../config/config";

const GPTMaintainerAdmin = () => {
  const [files, setFiles] = useState(["src/controllers/userController.js"]);
  const [task, setTask] = useState(
    "Analysiere die Dateien auf ungenutzte Funktionen, veraltete Routen oder Refactoring-Möglichkeiten."
  );
  const [language, setLanguage] = useState("de");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleRun = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/maintain`, {
        files,
        task,
        language
      });
      setResult(res.data);
    } catch (err) {
      console.error("❌ Fehler beim GPT-Aufruf:", err);
      setResult({ error: err.response?.data?.error || "Unbekannter Fehler" });
    } finally {
      setLoading(false);
    }
  };

  const handleAddFile = () => setFiles([...files, ""]);
  const handleFileChange = (i, value) => {
    const updated = [...files];
    updated[i] = value;
    setFiles(updated);
  };

  return (
    <div className="max-w-4xl mx-auto bg-gray-900 text-white p-6 rounded shadow-md">
      <h2 className="text-2xl font-bold mb-4">🧠 GPT Maintainer – Codeanalyse</h2>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1">🔍 Dateien analysieren</label>
        {files.map((file, i) => (
          <input
            key={i}
            type="text"
            value={file}
            onChange={(e) => handleFileChange(i, e.target.value)}
            className="w-full bg-gray-800 text-white p-2 mb-2 rounded border border-gray-600"
          />
        ))}
        <button onClick={handleAddFile} className="text-sm text-blue-400 hover:underline">
          + weitere Datei hinzufügen
        </button>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1">📝 Aufgabe</label>
        <textarea
          rows={4}
          value={task}
          onChange={(e) => setTask(e.target.value)}
          className="w-full bg-gray-800 text-white p-2 rounded border border-gray-600"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1">🌍 Sprache</label>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded border border-gray-600"
        >
          <option value="de">Deutsch</option>
          <option value="en">English</option>
          <option value="fr">Französisch</option>
        </select>
      </div>

      <button
        onClick={handleRun}
        disabled={loading}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        {loading ? "Analysiere..." : "Analyse starten"}
      </button>

      {result && (
        <div className="mt-6 bg-gray-800 p-4 rounded border border-gray-700">
          <h3 className="font-semibold text-green-400 mb-2">💡 Analyse-Ergebnis</h3>
          {result.error ? (
            <p className="text-red-400">{result.error}</p>
          ) : (
            <pre className="text-sm whitespace-pre-wrap">{result.output}</pre>
          )}
        </div>
      )}
    </div>
  );
};

export default GPTMaintainerAdmin;
